<template lang="html">
 	<div class="downloadList-container" >
      <div class="breadCrumb-container">
			    <el-breadcrumb separator-class="el-icon-arrow-right">
				      <el-breadcrumb-item>{{$t('message.alert')}}</el-breadcrumb-item>
				      <el-breadcrumb-item>{{$t('message.openAlert')}}</el-breadcrumb-item>
			    </el-breadcrumb>
		  </div>

      <div class="close-container">
          <el-button v-if="queryFlag == true" class="verifone-btn close-all" type="danger" plain icon="el-icon-close" @click="callStopAll">{{$t('message.closeAll')}}</el-button>
          <el-button v-else disabled class="verifone-btn close-all" type="danger" plain icon="el-icon-close" @click="callStopAll">{{$t('message.closeAll')}}</el-button>
      </div>

      <div class="body-container">
          <div class="table-container verifone-panel">
              <div class="table-main openAlert-table btn-table">
                  <template>
                      <el-table :data="tableData" style="width: 100%">
                          <el-table-column prop="sn" label="SN" :show-overflow-tooltip="true" />
                          <el-table-column prop="model" :label="$t('message.model')" width="100" />
                          <el-table-column prop="merchant" :show-overflow-tooltip="true" :label="$t('message.merchant')" />
                          <el-table-column prop="date" :show-overflow-tooltip="true" :label="$t('message.date')" />
                          <el-table-column prop="type" :show-overflow-tooltip="true" :label="$t('message.type')">
                              <template slot-scope="scope">
                                  <div class="typeHerf" @click="handleType(scope.row)">{{scope.row.type}}</div>
                              </template>
                          </el-table-column>
                          <el-table-column prop="level" :show-overflow-tooltip="true" :label="$t('message.level')" width="100">
                            	<template slot-scope="scope">
									                <span v-if="scope.row.level == 'm'" class="middle-icon" />
									                <span v-if="scope.row.level == 'h'" class="high-icon" />
									                <span v-if="scope.row.level == 'm'" size="small">{{$t('message.middle')}}</span>
                                  <span v-if="scope.row.level == 'h'" size="small">{{$t('message.high')}}</span>
                            	</template>
                          </el-table-column>
                          <el-table-column fixed="right" :label="$t('message.operation')" width="135" v-if="queryFlag == true">
								              <template slot-scope="scope">
		                        	    <el-button class="verifone-btn" type="danger" plain icon="el-icon-close" @click="callStopTaskBefore(scope.row)">{{$t('message.close')}}</el-button>
		                          </template>
                          </el-table-column>
                          <el-table-column fixed="right" :label="$t('message.operation')" width="135" v-else>
								              <template slot-scope="scope">
                                  <el-button class="verifone-btn" type="danger" disabled plain icon="el-icon-close" @click="callStopTaskBefore(scope.row)">{{$t('message.close')}}</el-button>
		                          </template>
                          </el-table-column>
                      </el-table>
                  </template>
              </div>

        		  <div class="pagination-main">
        			    <el-pagination  background layout="prev, pager, next" :total="totalPage*10" @current-change="queryAlertList" />
              </div>

        	</div>
      </div>

      <el-dialog title="" :visible.sync="alertDialogVisible" width="32%" class="quit-dialog terminalSN-dialog" >
          <div class="dialog-body">
              <div class="alert-item"><span>SN:&nbsp;&nbsp;{{snNo}}</span></div>
              <div v-show="type == 3">
                  <div class="alert-item">
                      <span>{{$t('message.tamperCode')}}:&nbsp;&nbsp;{{tamperCode}}</span>
                  </div>
              </div>
              <div v-show="type == 1">
                  <div class="alert-item">
                      <span>{{$t('message.downloadTasks')}}:&nbsp;&nbsp;{{downloadTask}}</span>
                  </div>
                  <div class="alert-item">
                      <span>{{$t('message.appName')}}:&nbsp;&nbsp;{{appName}}</span>
                  </div>
                  <div class="alert-item">
                      <span>{{$t('message.failureCode')}}:&nbsp;&nbsp;{{failureCode}}</span>
                  </div>
              </div>
                <div v-show="type == 2">
                    <div class="alert-item">
                        <span>{{$t('message.initialCoordinate')}}:&nbsp;&nbsp;{{targetCoordinate}}</span>
                    </div>
                    <div class="alert-item">
                        <span>{{$t('message.currentCoordinate')}}:&nbsp;&nbsp;{{currentCoordinate}}</span>
                    </div>
                    <div class="alert-item">
                        <span>{{$t('message.movingDistance')}}:&nbsp;&nbsp;{{movingDistance}}</span>
                    </div>
                </div>
                <div v-show="type == 4">
                    <div class="alert-item">
                        <span>{{$t('message.freeMemory')}}:&nbsp;&nbsp;{{freeMemory}}M</span>
                    </div>
                    <div class="alert-item">
                        <span>{{$t('message.freeStorage')}}:&nbsp;&nbsp;{{freeStorage}}M</span>
                    </div>
                </div>
            </div>
<!--
            <span slot="footer" class="dialog-footer">
                <el-button class="verifone-btn" type="primary" @click="terminalDialogVisible = false">{{$t('message.ok')}}</el-button>
            </span> -->
        </el-dialog>

 	</div>
</template>

<script>
export default {
  inject: ['reload'],
	data() {
		return {
      // cancelDialogVisible: false,
      currentType: null,
      cancelId: '',
      currentPage: 1,
      totalPage: 1,
			tableData: [],
      queryFlag: true,
      alertDialogVisible: false,
      cancelSuccess: this.$t('message.closeSuccess'),
      snNo: '',
      tamperCode: '',
      downloadTask: '',
      appName: '',
      failureCode: '',
      targetCoordinate: '',
      currentCoordinate: '',
      movingDistance: '',
      freeMemory: '',
      freeStorage: '',
      type: ''
		}
	},
    mounted() {
        this.queryAlertList(1);
        this.setQuery();
    },
	methods: {
        setQuery() {
            let roleArr = sessionStorage.getItem('verifoneRoleList').split(',').map(str => parseInt(str));
            this.queryFlag = !roleArr.includes(71);
        },
        handleType(row) {
            let obj = {
                'alertId': row.id
            };
            this.$axios({
                method: 'post',
                url: "/marketplace/alert/detail",
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    this.type = response.data.type;
                    this.snNo = row.sn;

                    console.log(response.data.detail);
                    if(this.type == 1) {
                        this.downloadTask = response.data.detail.taskName;
                        this.appName = response.data.detail.appName;
                        this.failureCode = response.data.detail.failureCode;
                    }else if(this.type == 3) {
                        this.tamperCode = response.data.detail.tamperCode;
                    }else if(this.type == 4) {
                        this.freeMemory = response.data.detail.memoryAvailable;
                        this.freeStorage = response.data.detail.flashAvailable;
                    }else if(this.type == 2) {
                        this.targetCoordinate = response.data.detail.targetCoordinate;
                        this.currentCoordinate = response.data.detail.coordinate;
                        this.movingDistance = response.data.detail.distance;
                    }
                    this.alertDialogVisible = true;
                }
            }).catch((err) => {
                console.log(err);
            });

        },
		/* handleCloseAll() {//方法已停用
            this.$axios({
                method: 'post',
                url: "/marketplace/alert/close/all",
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')}
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    // this.$emit('change-alert', response.data.count);
                    // that.alertValue = response.data.count;
                    // that.globalVar.setAlertNum(response.data.count);
                }
            }).catch((err) => {
                console.log(err);
            });
        }, */
     /*   showDeleteDialog(row) {//方法已停用
            this.cancelId = row.taskId;
            this.cancelDialogVisible = true;
        }, */
        queryAlertList(page) {
            let that = this,
                obj = {
                    pageNum: page
                };

            that.currentPage = page;

            this.$axios({
                method: 'post',
                url: '/marketplace/alert/page',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.tableData = response.data.alerts;
                    that.totalPage = response.data.totalPage;
                }
            }).catch((err) => {
                console.log(err);
            });
        },

        callStopTaskBefore(row){
          let _this = this;
          if (row.type == '移机警报' || row.type == 'Terminal Moved'){
            this.$confirm(this.$i18n.t('message.moveAlertCloseInfo'), this.warn, {
              confirmButtonText: this.$i18n.t('message.yes'),
              cancelButtonText: this.$i18n.t('message.no'),
              type: 'warning'
            }).then(() => {
              _this.callStopTask(row.id, true);
            }).catch(() => {
               _this.callStopTask(row.id, false);
              /* this.alertDialogVisible = false; */
            })
          }else{
            _this.callStopTask(row.id,false);
          }
        },

        callStopTask(id,closeMoveConf) {
          let that = this,
            obj = {
    				  "id": id,
              "closeMoveConf": closeMoveConf
            };

            this.$axios({
                method: 'post',
                url: '/marketplace/alert/close',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    that.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.$message({
                        type: "success",
                        message: this.cancelSuccess,
                        duration:'3000',
                    });
                    that.cancelDialogVisible = false;
                    that.queryAlertList(that.currentPage);
                    this.reload();
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        callStopAll() {
            let that = this;

            this.$axios({
                method: 'post',
                url: '/marketplace/alert/close/all',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')}
            }).then(response => {
                if (response.data.resultCode != 0) {
                    that.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.$message({
                        type: "success",
                        message: this.cancelSuccess,
                        duration:'3000',
                    });
                    that.cancelDialogVisible = false;
                    that.queryAlertList(that.currentPage);
                    this.reload();
                }
            }).catch((err) => {
                console.log(err);
            });
        },
	}

}
</script>

<style lang="css" scoped="scoped">
.table-container {
	margin-top: 10px;
}
.has-gutter {
	border-bottom: 1px solid #00a0e8;
}
.table-main {
	padding: 20px;
}
.pagination-main {
	padding: 10px 0;
}
.createBtn-main {
	display: flex;
	display: -webkit-flex;
	flex-direction: row;
	position: absolute;
	right: 0;
	bottom: 10px;
	align-items: center;
	padding-right: 10px;
}
.load-selector {
	background-color: #53bfb7!important;
	color: #fff!important;
	padding: 10px 15px;
	margin: 0 3px 0 20px;
}
.arrows-right {
	width: 25px;
	height: 25px;
	transform: rotate(180deg);
	position: relative;
	bottom: -7px;
}
.num-container {
	font-size: 15px;
	color: #666;
}
.taskName {
    color: #00A0E8;
    cursor: pointer;
}
.end-btn {
    color: #fff;
    background-color: #E51C23;
    padding: 8px 12px;
}
/* .is-disabled {
    color: #fff;
    background-color: #8E8E8E!important;
} */
.app-icon {
	width: 38px;
	height: 38px;
}
.detail-row {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    padding: 0 0 12px 0;
}
.downloadLabel {
    width: 128px;
}
.downloadDate {
    display: inline-block;
    width: 180px;
}
.title-container {
    padding-left: 20px;
}
.high-icon {
	display: inline-block;
	width: 16px;
	height: 16px;
	border-radius: 50%;
	position: relative;
	top: 3px;
	background-color: #db1e08;
	border: 3px solid #f5c8c2;
}
.middle-icon {
	display: inline-block;
	width: 16px;
	height: 16px;
	border-radius: 50%;
	position: relative;
	top: 3px;
	background-color: #fdb201;
	border: 3px solid #fdecbe;
}
.close-container {
    padding-right: 30px;
    margin-top: 12px;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
}
.close-all {
    width: 100px;
}
.typeHerf {
    color: #3ba2ec;
    cursor: pointer;
}
.dialog-body {
    padding: 0 20px 20px 20px;
}
.alert-item {
    margin-bottom: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/OpenAlert.vue